export enum ContentModuleEvent {
  CTA_CLICKED = 'CTA_CLICKED',
  INTERACTION = 'INTERACTION',
  MODULE_DISMISSED = 'MODULE_DISMISSED',
}

export enum Placement {
  BOTTOM_BAR = 'BOTTOM_BAR',
  CAROUSEL = 'CAROUSEL',
  ESCALATOR = 'ESCALATOR',
  LI_HOME_BOTTOM = 'LI_HOME_BOTTOM',
  SIGN_IN_RIGHT = 'SIGN_IN_RIGHT',
  SURVEY_SUMMARY_SIDE_BAR = 'SURVEY_SUMMARY_SIDE_BAR',
  TOP_BAR = 'TOP_BAR',
}
